module.exports = __webpack_public_path__ + "img/Id.1299ace9.png";